// The Sales Op Weekly Report guide (59_SopWeekly.jsx · ModuleHelp, Max 01/11).
const en = {
  weekT: 'Pick the week',
  weekB: 'Everything on this screen belongs to the week chosen here, shown as W-number and year. Older weeks can be looked at, but the job runs for the current week only.',
  stepsT: 'Three steps in order',
  stepsB: '1 Files, 2 Run, 3 Report. Each button carries a badge: how many files are in, how the last run ended, and when the output was written. Config on the right holds the lookup file the job reads.',
  dropT: 'Drop the weekly files',
  dropB: 'Drop all the week’s files here at once. Each one goes to its row by its name and is saved under the name the job looks for.',
  filesT: 'Which files are in',
  filesB: 'One row per expected file, marked Missing, Ready, or from another week. Use the row buttons to upload, download or remove a single file.',
  runT: 'Run the job',
  runB: 'Check the line above the button: it says whether every file is in. Run starts the same Python job as before, and the log below turns into one line per step.',
  reportT: 'Read the report',
  reportB: 'Pick a week to see the charts and tables the job produced, compared with the week before. Download 01_Output.xlsx, 02_Weekly-Report or the slides from the right.',
};
const ko = {
  weekT: '주차 선택',
  weekB: '이 화면의 모든 내용은 여기서 고른 주차(W번호와 연도)에 속합니다. 지난 주차는 볼 수 있지만 작업은 현재 주차만 실행됩니다.',
  stepsT: '순서대로 세 단계',
  stepsB: '1 Files, 2 Run, 3 Report입니다. 각 버튼의 배지에는 올라온 파일 수, 마지막 실행 결과, 출력 파일 작성 시각이 표시됩니다. 오른쪽 Config에는 작업이 읽는 조회 파일이 있습니다.',
  dropT: '주간 파일 올리기',
  dropB: '그 주의 파일을 한 번에 모두 여기에 놓으세요. 각 파일은 이름에 따라 해당 행에 들어가고, 작업이 찾는 이름으로 저장됩니다.',
  filesT: '올라온 파일 확인',
  filesB: '필요한 파일마다 한 행으로 없음, 준비됨, 다른 주차 중 하나가 표시됩니다. 행의 버튼으로 파일 하나를 올리거나 내려받거나 삭제할 수 있습니다.',
  runT: '작업 실행',
  runB: '버튼 위 문구에서 파일이 모두 올라왔는지 확인하세요. Run은 기존과 같은 Python 작업을 시작하고, 아래 로그는 단계별 한 줄로 정리됩니다.',
  reportT: '보고서 보기',
  reportB: '주차를 고르면 작업이 만든 차트와 표를 전주와 비교해 볼 수 있습니다. 오른쪽에서 01_Output.xlsx, 02_Weekly-Report, 슬라이드를 내려받을 수 있습니다.',
};
const vi = {
  weekT: 'Chọn tuần',
  weekB: 'Mọi thứ trên màn hình này thuộc về tuần bạn chọn ở đây, hiển thị dạng W-số tuần và năm. Có thể xem các tuần cũ, nhưng job chỉ chạy cho tuần hiện tại.',
  stepsT: 'Ba bước theo thứ tự',
  stepsB: '1 Files, 2 Run, 3 Report. Mỗi nút có một huy hiệu: đã có bao nhiêu file, lần chạy gần nhất kết thúc thế nào, và file output được ghi lúc nào. Config bên phải chứa file tra cứu mà job đọc.',
  dropT: 'Thả các file của tuần',
  dropB: 'Thả cùng lúc tất cả file của tuần vào đây. Mỗi file tự vào đúng dòng theo tên và được lưu với tên mà job tìm.',
  filesT: 'File nào đã có',
  filesB: 'Mỗi dòng là một file cần có, đánh dấu Thiếu, Sẵn sàng hoặc thuộc tuần khác. Dùng các nút trên dòng để upload, tải xuống hoặc xóa từng file.',
  runT: 'Chạy job',
  runB: 'Xem dòng phía trên nút: nó cho biết đã đủ file chưa. Run chạy đúng job Python như trước, và phần log bên dưới được gom thành một dòng cho mỗi bước.',
  reportT: 'Xem báo cáo',
  reportB: 'Chọn tuần để xem các biểu đồ và bảng job đã tạo, so với tuần trước. Bên phải có thể tải 01_Output.xlsx, 02_Weekly-Report hoặc bộ slide.',
};
const zh = {
  weekT: '选择周',
  weekB: '本页所有内容都属于这里选定的周，显示为 W 周数和年份。可以查看以前的周，但作业只能为当前周运行。',
  stepsT: '按顺序的三个步骤',
  stepsB: '1 Files，2 Run，3 Report。每个按钮上的标记显示已有多少文件、上次运行的结果以及输出文件的生成时间。右侧的 Config 存放作业读取的对照文件。',
  dropT: '拖入本周文件',
  dropB: '把这一周的所有文件一次性拖到这里。每个文件会按文件名进入对应行，并以作业查找的名称保存。',
  filesT: '已有哪些文件',
  filesB: '每个应有的文件一行，标记为缺失、就绪或属于其他周。用行内按钮可以上传、下载或删除单个文件。',
  runT: '运行作业',
  runB: '先看按钮上方那一行：它会告诉您文件是否齐全。Run 会启动与以往相同的 Python 作业，下方日志会整理成每个步骤一行。',
  reportT: '查看报表',
  reportB: '选择周即可查看作业生成的图表和表格，并与上一周对比。右侧可下载 01_Output.xlsx、02_Weekly-Report 或幻灯片。',
};

const dictionary = { ns: 'tourSopWeekly', en, ko, vi, zh };
export default dictionary;
